/**
 * Copyright (c) samjay.dev.
 *
 * Notes:
 * This source code is the private property of samjay.dev.
 * You cannot modify, share or copy these source codes without any formal authorization,
 * otherwise samjay.dev reserves the right to pursue any legal action.
 *
 * Developer: Sam Tsang (info@samjay.dev)
 */

import { Comment24Regular, ShareIos24Regular, StarEmphasis24Regular } from '@fluentui/react-icons';
import { getScroll } from 'history';
import React from 'react';

const BlogToolBar: React.FC<{
  starCount: number,
  commentCount: number,
  share: {
    aid?: number | string,
    title?: string,
    desc?: string
  },
  putLikes: () => void
}> = ({
  starCount, commentCount, share, putLikes
}) => {

  const handleSharing = async () => {
    if (navigator.share) {
      try {
        await navigator.share({
          url: `https://samjay.dev/blog/${share?.aid}`,
          title: share?.title,
          text: share?.desc ?? ''
        });
      } catch (err) {}
    }
  }

  return (
    <div>
      <div>
        <div onClick={() => putLikes()}>
          <div><StarEmphasis24Regular /></div>
          <div>{starCount}</div>
        </div>
        <div onClick={() => {
          if (getScroll() && document?.querySelector(`#comment`)) {
            getScroll()?.scrollIntoView(document?.querySelector(`#comment`)!)
          } else {
            document?.querySelector(`#comment`)?.scrollIntoView()
          }
        }}>
          <div><Comment24Regular /></div>
          <div>{commentCount}</div>
        </div>
        <div onClick={() => handleSharing()}>
          <div><ShareIos24Regular /></div>
        </div>
      </div>
    </div>
  );
}

export default BlogToolBar;